import type { TFunction } from "i18next";

export const translateStepType = (stepType: string, t: TFunction): string => {
  const key = `admin.flowConfigs.stepTypes.${stepType}`;
  const translated = t(key);
  return translated === key ? stepType : translated;
};

export const translateFlowType = (flowType: string, t: TFunction): string => {
  const key = `admin.flowConfigs.flowTypes.${flowType}`;
  const translated = t(key);
  return translated === key ? flowType : translated;
};

export const flowTypeDescription = (flowType: string, t: TFunction): string => {
  const key = `admin.flowConfigs.flowTypeDescriptions.${flowType}`;
  const translated = t(key);
  return translated === key ? "" : translated;
};
